<div fxLayout="column" fxFlex fxLayoutGap="24px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Create tenant</h2>
    <button mat-icon-button [routerLink]="['../']" matTooltip="Back to Tenant List">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()">
    <mat-card>
      <mat-card-content fxLayout="column" fxLayoutGap="16px">
        <mat-form-field appearance="outline">
          <mat-label>tenant ID</mat-label>
          <input
            matInput
            formControlName="id"
            placeholder="Enter unique tenant identifier"
            required
          />
          <mat-hint> Must be unique, lowercase, no spaces or special characters</mat-hint>
          @if (tenantForm.get('id')?.hasError('required')) {
            <mat-error> tenant ID is required </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter tenant name" required />
          <mat-hint> Friendly name for the tenant, used as default display name</mat-hint>
          @if (tenantForm.get('name')?.hasError('required')) {
            <mat-error> tenant name is required </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input
            matInput
            formControlName="description"
            placeholder="Optional description for this tenant"
          />
          <mat-hint>Optional description for this tenant, not visible to the public</mat-hint>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Roles</mat-label>
          <mat-select formControlName="roles" multiple>
            @for (role of roles; track role) {
              <mat-option [value]="role">
                {{ role }}
              </mat-option>
            }
          </mat-select>
          <mat-hint>Select one or more roles for this tenant</mat-hint>
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button mat-button type="button" (click)="onCancel()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="tenantForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? 'Creating...' : 'Create tenant' }}
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
